import { render, staticRenderFns } from "./at_a_glance.vue?vue&type=template&id=2537b732&"
import script from "./at_a_glance.vue?vue&type=script&lang=js&"
export * from "./at_a_glance.vue?vue&type=script&lang=js&"
import style0 from "./at_a_glance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports